<template>
    <div class="animated fadeIn">
        <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-form>
            <b-form-group
                    description="Enter the newsletter listing name."
                    label="Listing name"
                    label-for="listingName"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input id="listingName" v-model="listing.name" type="text" autocomplete="name"></b-form-input>
            </b-form-group>
            <b-form-group
                    label="Type"
                    label-for="listingType"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-radio-group id="listingType" v-model="listing.type"
                                    :plain="true"
                                    :options="listingTypes"
                                    :checked="listing.type">
                </b-form-radio-group>
            </b-form-group>
            <b-form-group
                    label="Status"
                    label-for="listingStatus"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-radio-group id="listingStatus" v-model="listing.status"
                                    :plain="true"
                                    :options="listingStatuses"
                                    :checked="listing.status">
                </b-form-radio-group>
            </b-form-group>
            <b-form-group
                    label="Description"
                    label-for="basicDesc"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input id="basicDesc" :textarea="true" v-model="listing.description" :rows="9" placeholder="Content.."></b-form-input>
            </b-form-group>
            <b-form-group
              label="External Provider Id"
              :label-cols="3"
              :horizontal="true"
            >
              {{listing.externalProviderId}}
            </b-form-group>
            <div slot="footer">
                <b-button type="button" size="sm" variant="primary" v-on:click="saveListing" v-show="editOption"><i class="fa fa-dot-circle-o" ></i>Save</b-button>
                <b-button type="button" size="sm" variant="primary" v-on:click="addListing" v-show="addOption"><i class="fa fa-dot-circle-o" ></i>Add</b-button>
            </div>
        </b-form>
    </div>
</template>
<script>
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {Listing} from "../../../models/NewsLetter/Listing"
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import {handleErrors, parseEnum} from "../../../shared/utils";
    const ListingRepo = RepositoryFactory.get('newsletterListing')

    export default {
        name: 'listing-form',
        components: {VueLoading},
        props: {
            listing: {
                type: Listing,
                default: new Listing()
            },
            addOption: {
                type: Boolean,
                default: false,
            },
            editOption: {
                type: Boolean,
                default: false,
            },
            listingId: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                isLoading: false,
                listingTypes: parseEnum(Listing.TYPES),
                listingStatuses: parseEnum(Listing.STATUS),
            }
        },
        methods: {
            saveListing () {
                this.isLoading = true
                ListingRepo
                    .updateListing(this.listing.id,
                        {
                            name: this.listing.name,
                            status: this.listing.status,
                            description: this.listing.description,
                            type: this.listing.type
                        })
                    .then(
                        () => {
                            this.isLoading = false,
                            this.flash('Listing has been updated','success')
                        }
                    )
                    .catch(
                        response => (
                            this.returnErrors(response)
                        )
                    )
            },
            addListing () {
                this.isLoading = true
                ListingRepo
                    .createListing(
                        {
                            name: this.listing.name,
                            type: this.listing.type,
                            description: this.listing.description,
                            status: this.listing.status,
                        })
                    .then(response => (
                        this.isLoading = false,
                        this.flash('Subscription has been created', 'success'),
                        this.$emit('input', response.data.data)
                    ))
                    .catch(response => (
                        this.returnErrors(response)
                    ))
            },
            returnErrors(response) {
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                ),
                this.isLoading = false
            },
        },
    }
</script>
